import React from 'react'
import PropTypes from 'prop-types'
import { Button, Dialog, DialogActions, DialogContent } from '@mui/material'
import { DefaultDialogTitle } from '../../components/styled/Dialog'
import i18n from 'simple-react-i18n'

const ScheduledExportEditModal = ({
    open = false,
    onClose = () => {},
    onSaveAndRun = () => {},
    title = i18n.editExport,
    children = null,
}) => (
    <Dialog
        open={open}
        onClose={onClose}
        maxWidth='lg'
        fullWidth
        slotProps={{ paper: { sx: { minHeight: '60vh' } } }}
    >
        <DefaultDialogTitle title={title} onClose={onClose} />
        <DialogContent>
            {children}
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose} variant='outlined'>{i18n.close}</Button>
            <Button onClick={onSaveAndRun} variant='contained'>{i18n.saveAndRun}</Button>
        </DialogActions>
    </Dialog>
)

ScheduledExportEditModal.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onSaveAndRun: PropTypes.func,
    title: PropTypes.string,
    children: PropTypes.node,
}

export default ScheduledExportEditModal